export const SET_TARIFF_NUMBERS = 'SET_TARIFF_NUMBERS'
export const RESET_TARIFF_NUMBERS = 'RESET_TARIFF_NUMBERS'
